import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'

export const MysteryBetInvestmentStyled = styled.div({
  backgroundColor: hexColors.blueDiamond,
  color: hexColors.white,
  marginTop: '1rem',
  position: 'relative',
})
